import CoreLibrary from "../../core/helpers/CoreLibrary";
import * as dateTimeHelper from './DateTimeHelper';

export default {
    extends: CoreLibrary,
    methods: {
        getTimeFromDateTime(dateTime) {
            const format = this.$store.state.settings.timeFormat;
            return dateTimeHelper.getTimeFromDateTime(dateTime, format);
        },
    }
}
